import { Box, Icon, Link } from '@cloudscape-design/components';
import { StarsIcon } from './StarsIcon';

export type SourceRatingRowProps = {
  icon: React.ReactNode;
  name: string;
  rating?: number;
  reviewCount?: number;
  link?: string;
  onClick?: () => void;
  stacked?: boolean;
};

export function SourceRatingRow({
  icon,
  name,
  rating,
  reviewCount,
  link,
  onClick,
  stacked = false,
}: SourceRatingRowProps) {
  const reviewText =
    reviewCount != null
      ? `${reviewCount.toLocaleString()} ${name} ${reviewCount === 1 ? 'review' : 'reviews'}`
      : `0 ${name} reviews`;

  return (
    <div
      className={
        stacked
          ? 'flex min-w-0 flex-col items-start gap-y-1'
          : 'flex flex-col gap-x-1 gap-y-0 min-[480px]:flex-row min-[480px]:items-center'
      }
    >
      {/* Icon + Rating + Stars stay together */}
      <span
        className={`inline-flex items-center gap-1 whitespace-nowrap ${onClick ? 'cursor-pointer hover:opacity-70' : ''}`}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        onKeyDown={
          onClick
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick();
                }
              }
            : undefined
        }
      >
        <Icon svg={icon} />
        <Box variant="span" fontWeight="bold" fontSize="body-s">
          {rating?.toFixed(1) ?? '0.0'}
        </Box>
        <span className="inline-flex">
          <StarsIcon stars={rating} />
        </span>
      </span>
      {/* Review count - below on mobile, inline on desktop */}
      <span className={stacked ? 'max-w-full break-words' : 'whitespace-nowrap'}>
        {link ? (
          <Link href={link} target="_blank" fontSize="body-s">
            {reviewText}
          </Link>
        ) : (
          <Box variant="span" color="text-body-secondary" fontSize="body-s">
            {reviewText}
          </Box>
        )}
      </span>
    </div>
  );
}
